import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { authService } from '../services/authService';
import { consumeRedirectAfterLogin } from '../utils/redirectAfterLogin';
import { ME_QUERY_KEY } from './useMe';
import type { LoginCredentials, AuthResponse } from '../types';

export function useLogin() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('auth');

  return useMutation<AuthResponse, Error, LoginCredentials>({
    mutationFn: (credentials) => authService.login(credentials),
    onSuccess: (data) => {
      queryClient.setQueryData(ME_QUERY_KEY, data.user);
      toast.success({ title: t('toasts.loginSuccess') });
      navigate(consumeRedirectAfterLogin(), { replace: true });
    },
    onError: (error: Error) => {
      toast.danger({ title: error.message || t('toasts.loginError') });
    },
  });
}
